import { render, staticRenderFns } from "./FAQViewer.vue?vue&type=template&id=5b57e2a0&scoped=true"
import script from "./FAQViewer.vue?vue&type=script&lang=js"
export * from "./FAQViewer.vue?vue&type=script&lang=js"
import style0 from "./FAQViewer.vue?vue&type=style&index=0&id=5b57e2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57e2a0",
  null
  
)

export default component.exports